import './DataDictionarySearchBar.scss';

import { DataDictionaryExportButton } from './DataDictionaryExportButton';
import React from 'react';
import { Space } from 'antd';
import { UpdateQueryParams } from '@hooks';
import { ViewQueryParams } from './CreateView';
import { ViewSelector } from './ViewSelector';

import { DataDictionarySearch, DataDictionarySearchQueryParams } from './DataDictionarySearch';

export type DataDictionarySearchBarParams = DataDictionarySearchQueryParams & ViewQueryParams;

export interface DataDictionarySearchBarProps {
	queryParams: DataDictionarySearchBarParams;
	updateQuery: UpdateQueryParams<DataDictionarySearchBarParams>;
}

export const DataDictionarySearchBar: React.FC<DataDictionarySearchBarProps> = ({ queryParams, updateQuery }) =>
	<Space className='data-dictionary-search-bar'>
		<DataDictionarySearch
			queryParams={ queryParams }
			updateQuery={ updateQuery } />
		<ViewSelector
			queryParams={ queryParams }
			updateQuery={ updateQuery } />
		<DataDictionaryExportButton
			applicationId={ queryParams.applicationId }
			complianceCategory={ queryParams.complianceCategory }
			filters={ queryParams?.filters }
			sonarObjectId={ queryParams?.sonarObjectId }
			sonarObjectType={ queryParams?.sonarObjectType }
			tagId={ queryParams?.tagId } />
	</Space>;
